<template>
  <div class="hello" style="min-height: 100vh; background-color: #f3f3f3">
    <van-sticky>
      <van-nav-bar
        style="background: #1989fa; color: #ffffff"
        @click-right="logOut"
      >
        <template #title
          ><span style="color: #ffffff">{{ "我的订单" }}</span></template
        >
        <template #right
          ><span style="color: #ffffff">
            退出
            <van-icon
              name="close"
              style="color: #ffffff; margin-right: 6px" /></span
        ></template>
      </van-nav-bar>
      <van-tabs v-model:active="active" @change="selectTab">
        <van-tab
          v-for="(tab, idx) in tabs"
          :title="tab.title"
          :key="idx"
        ></van-tab>
      </van-tabs>
    </van-sticky>
    <van-list
      :loading="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="getList"
    >
      <div class="box">
        <div
          class="item"
          v-for="item in dataList"
          @click="viewItem(item.id)"
          :key="item.id"
        >
          <div class="title">
            单号 {{ item.order_sn }}
            <span class="tags">
              <van-tag type="danger" v-if="item.status == 1">{{
                item.status_txt
              }}</van-tag>
              <van-tag type="warning" v-else-if="item.status == 2">{{
                item.status_txt
              }}</van-tag>
              <van-tag type="success" v-else-if="item.status == 3">{{
                item.status_txt
              }}</van-tag>
              <van-tag type="warning" v-else-if="item.status == 4">{{
                item.status_txt
              }}</van-tag>
              <van-tag type="default" v-else>{{ item.status_txt }}</van-tag>
            </span>
          </div>
          <div class="content">
            <div class="right">
              <van-text-ellipsis :content="item.title" />
              <div>
                总金额：
                <span class="price"
                  >￥<b>{{ item.money_info.total }}</b></span
                >
              </div>
              <div>
                优惠金额：
                <span class="price"
                  >￥<b>{{ item.money_info.discount }}</b></span
                >
                <span
                  v-if="item.discount"
                  style="padding-left: 10px; color: #ff6600"
                  >{{ item.price_remark }}</span
                >
              </div>
              <div>
                需要支付：
                <span class="price"
                  >￥<b>{{ item.money_info.need_pay }}</b></span
                >
              </div>
              <div>
                实付：
                <span class="price"
                  >￥<b>{{ item.money_info.pay }}</b></span
                >
              </div>
              <div>
                退款：
                <span class="price"
                  >￥<b>{{ item.money_info.refund }}</b></span
                >
              </div>
              <div>
                结余：
                <span class="price"
                  >￥<b>{{ item.money_info.last }}</b></span
                >
              </div>
              <div>出行日期：{{ item.godate }}</div>
              <div>下单时间：{{ item.create_time }}</div>
              <div v-if="item.status == 4 && item.sure_remark">
                备注：<span style="padding-left: 10px; color: #ff6600">{{
                  item.sure_remark
                }}</span>
              </div>
            </div>
          </div>
          <div
            class="footer"
            v-if="item.status == 1 || item.status == 2 || item.status == 4"
          >
            <van-button
              size="small"
              v-if="item.status == 1"
              type="primary"
              @click="changeOrder(item, 'editPrice')"
              >订单改价</van-button
            >
            <van-button
              size="small"
              v-if="item.status == 2"
              @click="changeOrder(item, 'sureOrder')"
              type="warning"
              >订单确认</van-button
            >
            <van-button
              size="small"
              v-if="item.status == 4"
              @click="changeOrder(item, 'refund')"
              type="danger"
              >退款</van-button
            >
          </div>
        </div>
      </div>
    </van-list>

    <van-popup
      v-model:show="showBox"
      round
      position="bottom"
      :style="{ minHeight: '30%' }"
    >
      <div style="margin-top: 10px">
        <div
          style="
            text-align: center;
            font-size: 16px;
            line-height: 30px;
            margin-bottom: 10px;
          "
        >
          {{ saveData.actTitle }}
        </div>
        <van-cell-group inset label-width="auto">
          <van-cell title="订单号" :value="saveData.order_sn" />
          <van-cell title="当前状态" :value="saveData.status_txt" />
          <van-cell title="总金额" :value="saveData.money_info.total" />
          <template v-if="saveData.sact == 'editPrice'">
            <van-field
              v-model="saveData.newVal"
              placeholder="负数为优惠，正数为加金额"
              input-align="right"
              type="number"
              label="优惠金额"
            />
            <van-field
              v-model="saveData.priceRemark"
              rows="2"
              autosize
              input-align="right"
              label="备注"
              type="textarea"
              placeholder="请输入操作说明"
            />
          </template>
          <template v-else-if="saveData.sact == 'sureOrder'">
            <van-field label="确认结果" input-align="right">
              <template #input>
                <van-radio-group
                  v-model="saveData.newVal"
                  direction="horizontal"
                >
                  <van-radio name="success">成功</van-radio>
                  <van-radio name="fail">失败</van-radio>
                </van-radio-group>
              </template>
            </van-field>
            <van-field
              v-model="saveData.sureRemark"
              rows="2"
              autosize
              label="备注"
              input-align="right"
              type="textarea"
              placeholder="说明可为空"
            />
          </template>
          <template v-else-if="saveData.sact == 'refund'">
            <van-cell title="实付金额" :value="saveData.money_info.pay" />
            <van-field
              v-model="saveData.newVal"
              :placeholder="'最多可退' + saveData.pay"
              input-align="right"
              type="number"
              label="退款金额"
            />
            <van-field
              v-model="saveData.refundRemark"
              rows="2"
              autosize
              label="备注"
              input-align="right"
              type="textarea"
              placeholder="退款备注说明必填"
            />
          </template>
        </van-cell-group>
        <div style="margin: 16px">
          <van-button
            round
            block
            type="primary"
            native-type="submit"
            @click="saveAction"
            >确认</van-button
          >
        </div>
      </div>
    </van-popup>

    <my-footer
      :view="hasLoad"
      :showTabBar="true"
      activeStr="user"
      :showElse="false"
    ></my-footer>
  </div>
</template>
<script>
import { ref } from "vue";
import { showToast, showConfirmDialog } from "vant";
import MyFooter from "@/components/myFooter.vue";

export default {
  name: "user",
  components: {
    MyFooter,
  },
  data() {
    return {
      hasLoad: false,
      showBox: false,
      active: 1,
      tags: false,
      loading: false,
      finished: false,
      saveData: {},
      error: false,
      dataList: [],
      per_page: 10,
      last_page: 0,
      current_page: 0,
      total: 0,
      tag: "unpay",
      tabs: [
        {
          title: "全部",
          tag: "all",
        },
        {
          title: "待付款",
          tag: "unpay",
        },
        {
          title: "待确认",
          tag: "pay",
        },
        {
          title: "成功",
          tag: "success",
        },
        {
          title: "失败",
          tag: "fail",
        },
      ],
    };
  },
  setup() {
    const onClickLeft = () => history.back();
    return {
      onClickLeft,
    };
  },
  mounted() {
    this.hasLoad = true;
  },
  methods: {
    selectTab(val) {
      this.tag = this.tabs[val].tag;
      this.reload();
    },
    changeOrder(item, act) {
      if (act == "editPrice") {
        this.saveData = {
          sact: "editPrice",
          id: item.id,
          actTitle: "订单改价",
          status: item.status,
          order_sn: item.order_sn,
          status_txt: item.status_txt,
          money_info: item.money_info,
          newVal: "",
          priceRemark: "",
        };
      } else if (act == "sureOrder") {
        this.saveData = {
          sact: "sureOrder",
          id: item.id,
          actTitle: "订单确认",
          status: item.status,
          order_sn: item.order_sn,
          status_txt: item.status_txt,
          money_info: item.money_info,
          newVal: "",
          sureRemark: "",
        };
      } else if (act == "refund") {
        this.saveData = {
          sact: "refund",
          id: item.id,
          actTitle: "订单退款",
          status: item.status,
          pay: item.pay,
          order_sn: item.order_sn,
          status_txt: item.status_txt,
          money_info: item.money_info,
          newVal: "",
          refundRemark: "",
        };
      } else {
        showToast("未知操作");
        return;
      }
      this.showBox = true;
    },
    saveAction() {
      let msg = "";
      if (this.saveData.sact == "editPrice") {
        if (this.saveData.newVal == "" || this.saveData.newVal == 0) {
          showToast("请填写优惠金额");
          return;
        }
        if (this.saveData.priceRemark == "") {
          showToast("请填写操作说明");
          return;
        }

        msg = `设置优惠金额为${this.saveData.newVal}吗?`;
      } else if (this.saveData.sact == "sureOrder") {
        if (this.saveData.newVal == "fail") {
          msg = `设置预订结果为【失败】吗?`;
        } else {
          msg = `设置预订结果为【成功】吗?`;
        }
      } else if (this.saveData.sact == "refund") {
        if (
          this.saveData.newVal == "" ||
          parseFloat(this.saveData.newVal) > parseFloat(this.saveData.pay)
        ) {
          showToast("退款金额有误，请确认！");
          return;
        }
        msg = `确认退款 ￥${this.saveData.newVal} 吗?`;
      } else {
        showToast("未知操作");
        return;
      }
      let _this = this;

      showConfirmDialog({
        title: "操作确认",
        message: msg,
      })
        .then(() => {
          this.loading = true;
          this.$http
            .postData("/Order/editOrderPrice", {
              ...this.saveData,
              hide_success: false,
            })
            .then((res) => {
              this.loading = false;
              this.showBox = false;
              setTimeout(function () {
                _this.reload();
              }, 1000);
            })
            .catch((error) => {
              this.loading = false;
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    viewItem(item) {
      return;
      if (!item) return;
      let url = "/order/detail/" + item;
      this.$router.push(url);
    },
    reload() {
      this.dataList = [];
      this.finished = false;
      this.current_page = 0;
      this.total = 0;
      this.last_page = 0;
      this.getList();
    },
    getList() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$http
        .postData("/index/getOrderList", {
          table: "Order",
          tag: this.tag,
          pageInfo: {
            page_size: this.per_page,
          },
          page: this.current_page + 1,
        })
        .then((res) => {
          this.loading = false;
          res.data.map((item) => {
            this.dataList.push(item);
          });
          this.current_page = res.current_page;
          this.total = res.total;
          if (res.last_page == res.current_page || res.last_page == 0) {
            this.finished = true;
            return;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.finished = true;
        });
    },
    logOut() {
      showConfirmDialog({
        title: false,
        message: "确认退出吗？",
      })
        .then(() => {
          localStorage.removeItem("userInfo");
          localStorage.removeItem("openid");
          localStorage.removeItem("mini");
          this.$router.push({ path: "/" });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>
  <style scoped>
.tops {
  text-align: center;
  margin: 20px;
}
.tops .title {
  font-size: 16px;
  line-height: 30px;
}
.tops .info {
  font-size: 12px;
  line-height: 30px;
  color: #666666;
}
.box {
}
.item {
  margin: 20px;
  background: #fff;
  padding: 0 10px;
  box-shadow: 0 0px 10px 0 rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}
.item .title {
  font-size: 14px;
  line-height: 2rem;
  border-bottom: 1px solid #f3f3f3;
  padding: 6px 0;
  position: relative;
}
.item .title .tags {
  position: absolute;
  z-index: 1;
  right: 0px;
  top: 6px;
}
.item .content {
  font-size: 12px;
  padding: 10px 0;
}
.item .right {
  line-height: 24px;
  color: #666;
}

.item .content .thumb {
  width: 60px;
  height: 60px;
  border-radius: 6px;
}
.item .footer {
  font-size: 1rem;
  color: #999;
  border-top: 1px solid #f3f3f3;
  padding: 6px;
  text-align: center;
}
</style>
  